import { useToggle } from 'react-use';
import { useState } from 'react';
import get from 'lodash/get';
import unset from 'lodash/unset';

const useDevicesListLogic = (props) => {
  const {
    device = {},
    calendars,
    onFetchDevice,
    onFetchLogs,
    onFetchScreenshot,
  } = props;
  const [isOpen, toggle] = useToggle(false);
  const [activeId, setActiveId] = useState(null);

  const onClick = (id) => (e) => {
    if (e.currentTarget.contains(e.target)) {
      const sameDevice = activeId === id;

      if (sameDevice || !isOpen) {
        toggle();
      }

      if (!sameDevice) {
        onFetchDevice(id);
        onFetchLogs(id);
        onFetchScreenshot(id);
      }

      setActiveId(!sameDevice ? id : null);
    }
  };

  const onClose = () => {
    toggle();
    setActiveId(null);
  };

  const createInitialValues = () => {
    if (!activeId) return {};

    const initialValues = {
      name: device.name,
      calendar: get(device, 'calendar.id', null),
      timezone: device.timezone,
    };

    if (!initialValues.calendar) {
      unset(initialValues, 'calendar');
    }

    if (!initialValues.timezone) {
      unset(initialValues, 'timezone');
    }

    return initialValues;
  };

  const onGetScreenshot = () => props.onGetScreenshot(device.id);
  const onLogsRequest = () => props.onLogsRequest(device.id);

  return {
    ...props,
    device,
    calendars,
    activeId,
    isOpen,
    toggle,
    createInitialValues,
    onClick,
    onClose,
    onGetScreenshot,
    onLogsRequest,
  };
};

export default useDevicesListLogic;
